import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ResultModel } from '../models/result-model';

@Injectable({
  providedIn: 'root'
})
export class CustomPagingService {
  baseURL = environment.apiUrl;
  constructor(private http: HttpClient) { }

  getResultbyActionName(actionName: string, filter: any): Observable<any> {
    return this.http.post<any>(this.baseURL + actionName, filter);
  }

}
